import { isValidEmail } from 'src/utils/email';
import i18next from 'src/utils/i18n';
import { StateFormFieldsType, StateFormInputOptionsType, StateFormPossibleValue } from 'src/utils/stateForm/index';
import isArray from 'lodash/isArray';

export const formStateGenerateErrors = (
  value: StateFormPossibleValue,
  validationOptions: StateFormInputOptionsType,
  fieldType: StateFormFieldsType,
  name: string
): string[] => {
  const errorLabel = validationOptions?.errorLabel || name;

  const errorsToSet = []; // the array for collecting errors

  const isTypeMasked = fieldType === 'masked';

  /** required */
  if (validationOptions?.required) {
    let setErr = false;

    switch (fieldType) {
      case 'masked': {
        /** if the value isn't fully set */
        if (!value || value.toString().includes('_')) {
          setErr = true;
        }
        break;
      }
      case 'number': {
        if (value !== 0 && !value) {
          setErr = true;
        }
        break;
      }
      case 'checkbox': {
        // for checkbox group component
        if (isArray(value)) {
          setErr = !value.length;
        } else if (!value) {
          setErr = true;
        }
        break;
      }
      default: {
        if (!value) {
          setErr = true;
        }
      }
    }

    if (setErr) {
      errorsToSet.push(
        validationOptions.requiredMessage || i18next.t('common.validation.required', { label: errorLabel })
      );

      return errorsToSet;
    }
  }
  if (isTypeMasked && value?.toString().includes('_')) {
    /** if the value isn't fully set */
    errorsToSet.push(
      validationOptions?.requiredMessage || i18next.t('common.validation.maskedNotFull', { label: errorLabel })
    );
  }

  /** minLength */
  if (validationOptions?.minLength) {
    if ((value || '').toString().length < validationOptions.minLength) {
      errorsToSet.push(
        validationOptions.minLengthMessage ||
          i18next.t('common.validation.minLength', { label: errorLabel, length: validationOptions.minLength })
      );
    }
  }

  /** email pattern */
  if (fieldType === 'email' && !isValidEmail(value?.toString() ?? '')) {
    /** always set an error if required or if not but has a value */
    if (validationOptions.required || (!validationOptions.required && value)) {
      errorsToSet.push(i18next.t('common.validation.emailInvalid', { label: errorLabel }));
    }
  }

  /** maxLength */
  if (validationOptions?.maxLength) {
    if ((value || '').toString().length > validationOptions.maxLength) {
      errorsToSet.push(
        validationOptions.maxLengthMessage ||
          i18next.t('common.validation.maxLength', { label: errorLabel, length: validationOptions.maxLength })
      );
    }
  }

  /** custom validate */
  if (validationOptions?.validate) {
    const validateResponse = validationOptions.validate(value);

    if (validateResponse === false) {
      errorsToSet.push(i18next.t('common.validation.validate', { label: errorLabel }));
    } else if (typeof validateResponse === 'string') {
      errorsToSet.push(validateResponse);
    }
  }

  return errorsToSet;
};
